import React from 'react';
import Sidebar from './Sidebar';
import { Lock } from 'lucide-react';

const Layout = ({ 
  children, 
  favoriteApps = [], 
  onOpenApp, 
  onToggleFavorite,
  onReorderFavorites,
  onLogout,
  API,
  maintenanceActive = false,
  isAdmin = false,
  showSidebar = true,
  hasNewsSidebar = false,
}) => {
  if (!showSidebar) {
    return <>{children}</>;
  }

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      {/* Sidebar */}
      <Sidebar
        favoriteApps={favoriteApps}
        onOpenApp={onOpenApp}
        onToggleFavorite={onToggleFavorite}
        onReorderFavorites={onReorderFavorites}
        onLogout={onLogout}
        API={API}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-h-screen overflow-hidden">
        {/* Bandeau Mode Maintenance pour les admins */}
        {maintenanceActive && isAdmin && (
          <div className="text-white py-3 px-4 shadow-lg flex-shrink-0" style={{ backgroundColor: '#f59e0b' }}>
            <div className="flex items-center justify-center gap-3">
              <Lock size={20} />
              <span className="font-semibold text-lg">
                MODE MAINTENANCE ACTIVÉ - Seuls les administrateurs peuvent accéder à l'application
              </span>
            </div>
          </div>
        )}

        {/* Scrollable Content — padding-right desktop si sidebar actualités ouverte */}
        <main className="flex-1 overflow-y-auto">
          <div className={hasNewsSidebar ? 'lg:pr-[max(15vw,220px)]' : ''}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
